import { render, staticRenderFns } from "./payments.vue?vue&type=template&id=51784316&scoped=true&"
import script from "./payments.vue?vue&type=script&lang=coffee&"
export * from "./payments.vue?vue&type=script&lang=coffee&"
import style0 from "./payments.vue?vue&type=style&index=0&id=51784316&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51784316",
  null
  
)

export default component.exports